/// <amd-module name="Build/Common/Library/RepositoryService" />
import { RepositoryDescriptor } from "Build/Common/Library/Types";
import * as Resources from "Build/Common/Library/Resources";

import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IServerException, IVssContributionService } from "VSS/Platform/Contribution";

import { format } from "VSS/Core/Util/String";

/**
 * Get config files for a given repository using the common data provider.
 */

export interface ConfigFilesResult {
    files: string[];
}

export enum ConfigFileType {
    Yaml = "yaml",
    Docker = "docker"
}

export interface IRepositoryService extends IVssService {
    getConfigFiles(repository: RepositoryDescriptor, configFileType: ConfigFileType): Promise<ConfigFilesResult>;
}

class RepositoryService extends VssService implements IRepositoryService {
    public getConfigFiles(repository: RepositoryDescriptor, configFileType: ConfigFileType): Promise<ConfigFilesResult> {
        const dataProviderId = "ms.vss-build-web.find-config-files-data-provider";
        const requestParams = {
            connectionId: repository.connectionId,
            sourceProvider: repository.sourceProviderType,
            repositoryId: repository.id,
            repositoryName: repository.name,
            configFileType: configFileType,
            branch: repository.defaultBranch,
        };

        return this.getDataProviderResult(dataProviderId, repository, requestParams, Resources.ConfigFileDataProviderErrorMessage);
    }

    private getDataProviderResult(dataProviderId: string, repository: RepositoryDescriptor, requestParams: any, error: string): Promise<any> {
        const errorMessage = format(error, repository.name || repository.id);
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getDataAsync(dataProviderId, requestParams, true)
            .then((result: any) => {
                if (result) {
                    return result;
                }
                else {
                    const ex: IServerException = contributionService.getDataProviderExceptions()[dataProviderId];
                    const message = (ex && ex.message) || errorMessage;
                    throw new Error(message);
                }
            }, (error: Error) => {
                throw new Error((error && error.message) || errorMessage);
            });
    }
}

Services.add("IRepositoryService", { serviceFactory: RepositoryService });
